/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type LinkColumn_viewer = {
    readonly " $fragmentRefs": FragmentRefs<"SocialLinkRow_viewer" | "FooterSubscribe_viewer">;
    readonly " $refType": "LinkColumn_viewer";
};
export type LinkColumn_viewer$data = LinkColumn_viewer;
export type LinkColumn_viewer$key = {
    readonly " $data"?: LinkColumn_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"LinkColumn_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "LinkColumn_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SocialLinkRow_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "FooterSubscribe_viewer",
      "args": null
    }
  ]
};
(node as any).hash = '5d3d19d4b92bc2a4a497ea5c33c6fbec';
export default node;
